import React from 'react'
import classNames from 'classnames'

import './load-more-button.scss'

const LoadMoreButton = (props) => {
  const { children, onClick, disabled, isLoading } = props

  const buttonClasses = classNames('load-more-comments')

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled || isLoading}>
      {isLoading && <i className='fad fa-spinner-third' />}
      {!isLoading && children}
    </button>
  )
}

export default LoadMoreButton
